import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchTable } from '../helpers/sagaHelpers';

function* watchFetchPrimaryManagersTable() {
  yield takeLatest('primaryManagers/fetchTable', fetchTable);
}

export default function* rootSaga() {
  yield all([fork(watchFetchPrimaryManagersTable)]);
}
